




import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateRouteItem } from "../../../../../../features/addLoad/addLoadSlice"
import { useEffect } from "react"

const Container = styled.div`
    width: 220px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }

        &::-webkit-calendar-picker-indicator {
            filter: ${({ theme }) => theme.inputDateIconColor};
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
    @media (max-width: 1200px){
        width: 150px !important;
    }
`

const BosaltmaEnGecDateInput = ({data, name, isRequired}) => {

    const [text, setText] = useState(data.dateEngec)

    const dispatch = useDispatch()

    useEffect(()=> {
        setText(data.dateEngec)
    },[data.dateEngec])

    const handleChange = (e) => {
        setText(e.target.value)

        const updatedItem = {
            id: data.id,
            dateEngec: e.target.value
        }
        
        dispatch(updateRouteItem(updatedItem))
    }

    const minDate = new Date().toJSON().slice(0, 10)

  return (
    <Container value={text} radius={"5px"}>
        <input min={minDate} type="date" id={"text"} onChange={handleChange} value={text} name={name}/> 
        <label htmlFor={"text"}>En Geç Boşaltma Tarihi</label>
    </Container>
  )
}

export default BosaltmaEnGecDateInput